// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./components-wpbbsa/form-item-hs-vas-statistics/form-item-hs-vas-statistics.component.scss
// module id = 915
// module chunks = 0